import React from 'react';
import { Users, Target, Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();
  
  const features = [
    {
      icon: <Users size={32} />,
      title: t('about_feature1_title'),
      description: t('about_feature1_desc')
    },
    {
      icon: <Target size={32} />,
      title: t('about_feature2_title'),
      description: t('about_feature2_desc')
    },
    {
      icon: <Heart size={32} />,
      title: t('about_feature3_title'),
      description: t('about_feature3_desc')
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('about_title')}
            </h2>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-6"></div>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              {t('about_subtitle')}
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-zinc-800/50 backdrop-blur-sm p-8 rounded-lg border border-zinc-700 hover:border-red-500 transition-all duration-300 hover:transform hover:scale-105"
              >
                <div className="text-red-500 mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Mission Statement */}
          <div className="bg-zinc-800/30 backdrop-blur-sm border border-zinc-700 rounded-lg p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-1">
                <h3 className="text-3xl font-bold text-white mb-4">
                  {t('about_mission_title')}
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed mb-4">
                  {t('about_mission_text1')}
                </p>
                <p className="text-gray-400 leading-relaxed">
                  {t('about_mission_text2')}
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="w-48 h-48 rounded-lg overflow-hidden border-4 border-red-500 shadow-lg shadow-red-500/20">
                  <img
                    src="https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/tltd1h41_WhatsApp%20Image%202026-04-09%20at%2012.50.42.jpeg"
                    alt="Battle Action"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
